import { render, staticRenderFns } from "./AttachmentAddView.vue?vue&type=template&id=3595f4e8&scoped=true"
import script from "./AttachmentAddView.vue?vue&type=script&lang=js"
export * from "./AttachmentAddView.vue?vue&type=script&lang=js"
import style0 from "./AttachmentAddView.vue?vue&type=style&index=0&id=3595f4e8&prod&scoped=true&lang=css"
import style1 from "./AttachmentAddView.vue?vue&type=style&index=1&id=3595f4e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3595f4e8",
  null
  
)

export default component.exports